/*eslint-disable */
import LayerService from '@/services/layers/LayerService';

// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax,import/no-extraneous-dependencies
import store from '@/store/index';

import {
  LayerGroup, LeafletEvent, Marker,
}                             from 'leaflet';
import { IFeatureCollection, AllMergedCategorySpots }     from '@/interfaces/IFeatureCollection';
import { IParkingLastStatus } from '@/interfaces/IParkingLastStatus';
import { IModalData }         from '@/services/layers/IModalData';


export default class ParkingLayerService extends LayerService {
  protected clusteringConstant = 18;

  public markerIcon = 'parkingi.svg';

  public lastStatusState: boolean = false;

  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    const lastStatus: [] = !!metaData.last_status ? metaData.last_status.occupancy : [];
    const parkingSpots: [] = !!metaData.parkingSpots ? metaData.parkingSpots : [];
    const mergedArr = [...lastStatus, ...parkingSpots];
    const mergedArrValues = this.mergeObjectsInUnique(mergedArr, 'category');
    const allCategorySpots = this.sumParkingCategoryPlaces(mergedArrValues, 'spots');
    const allCategoryOccupancySpots = this.sumParkingCategoryPlaces(
      mergedArrValues, 'occupied',
    );

    let parkingSpotsTable: string = '';
    mergedArrValues.forEach((item: AllMergedCategorySpots) => {
      parkingSpotsTable += `<tr>
                        <td>${!!item.category ? item.category : this.noData}</td>
                        <td>${!!item.spots ? item.spots : this.noData}</td>
                        <td>${!!item.occupied ? item.occupied : this.noData}</td>
                        </tr>`;
    });


    const hasSpots = !!metaData.last_status && metaData.last_status.occupancy.length > 0
      ? 'parking-data--has-data'
      : 'parking-data--empty-data';

    const template: string = `
    <div class="parking-data">
      <div class="parking-data__description">${metaData.description}</div>
      <div class="${hasSpots}">
        <div class="parking-data__table">
          <table>
            <thead>
              <th>Kategoria miejsc</th>
              <th>Wszystkie miejsca</th>
              <th>Zajęte miejsca</th>
            </thead>
            <tbody>
              ${parkingSpotsTable}
            </tbody>
            <tfoot>
              <th>Razem:</th>
              <th>${!!allCategorySpots ? allCategorySpots : '-'}</th>
              <th>${!!allCategoryOccupancySpots ? allCategoryOccupancySpots : '-'}</th>
            </tfoot>
          </table>
        </div>
        <div class="empty-data">
          Brak informacji o aktualnej zajętości.
        </div>
      </div>
    </div>
    `;


    const lastUpdate = !!metaData.last_status && !!metaData.last_status.date_time
                       ? metaData.last_status.date_time as string
                       : this.noData;


    const modalData: IModalData = {
      title: metaData.name,
      content: template,
      navigationPoint: leafletMarker,
      lastUpdate: lastUpdate,
      icon: this.markerIcon,
    };

    store.commit('displayModal', modalData);
  };

  redrawLayer = (): LayerGroup<any> => {
    const points: IFeatureCollection = store.state.parkings;
    return this.generatePruneClusterMarkerLayer(points);
  };



  protected generateHtmlPointTemplate = (metaData: any, leafletMarker: Marker<any>): string => {
    // eslint-disable-next-line global-require
    let parkingSpotsNumber: number = 0;
    let parkingSpots: string = '';

    if (metaData.carParkingSpots !== undefined && metaData.showAvailability === true) {
      const lastStatus: IParkingLastStatus = metaData.last_status as IParkingLastStatus;
      if (lastStatus !== undefined) {
        const sumCategoryParkinSpots = this.sumParkingCategoryPlaces(
          metaData.parkingSpots, 'spots',
        );
        const sumCategoryOccupancySpots = this.sumParkingCategoryPlaces(
          metaData.last_status.occupancy, 'occupied',
        );

        parkingSpotsNumber = sumCategoryParkinSpots - sumCategoryOccupancySpots;
        parkingSpots = (parkingSpotsNumber >= 9) ? '9+' : parkingSpotsNumber.toString(10);
        this.lastStatusState = true;
      } else {
        this.lastStatusState = false;
        parkingSpotsNumber = 0;
        parkingSpots = 'bd';
      }
    } else if (metaData.showAvailability === true) {
      this.lastStatusState = false;
      parkingSpots = 'bd';
    }

    let divMarkerIcon = this.markerIcon;
    let colorClass = '';

    if (parkingSpotsNumber >= 1) {
      divMarkerIcon = 'parkingi--green.svg';
    }

    if (parkingSpotsNumber === 0 && !!this.lastStatusState) {
      divMarkerIcon = 'parkingi--red.svg';
    }

    if (parkingSpotsNumber === 0 && !this.lastStatusState) {
      divMarkerIcon = this.markerIcon;
    }

    // brak ostatniego statusu - czyli zajetosci i brak informacji o zajetosci showAvailability = false
    if (!metaData.last_status && !metaData.showAvailability) {
      divMarkerIcon = this.markerIcon;
    }

    const template: string = `
        <div class="map-simple-icon map-simple-icon--parking-meter ${colorClass}"
            style='background-image: url("${require('@/assets/img/map-icons/' + divMarkerIcon)}")'>
              <span class="map-simple-icon__number">${parkingSpots}</span>
        <div>
      `;

    return template;
  }
}
